<template>
	<div class="voucherList">
		<back-to></back-to>
		<ul class="voucherList-con">
			<li v-for="(item, index) in list">
				<span class="voucherList-left">
					<p class="voucherList-title">{{item.name}}</p>
					<p class="voucherList-time">有效期{{item.startUseDate}}</p>
				</span>
				<span class="voucherList-button" @click="object = item,show = true">查看</span>
			</li>
		</ul>
		<van-popup v-model="show" class="voucherList-popup">
			<div class="voucherList-pop">
				<img src="https://jiaqi.obs.cn-north-1.myhuaweicloud.com/sweetourmini/tc_bg%402x.png" alt=""
					class="voucherList-popup-img">
				<section class="voucherList-popup-content">
					<h2>{{object.name}}</h2>
					<span class="voucherList-popup-contentc">
						<font>{{object.exchangeInfo}}</font>
						<p @click="copy(object.exchangeInfo)">复制</p>
					</span>
					<span class="voucherList-popup-content_time">有效期{{object.startUseDate}}</span>
					<span class="voucherList-popup-content_des" v-html="object.description"></span>
				</section>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import BackTo from "@/components/BackTo";
	import {
		Toast
	} from 'vant';
	export default {
		name: 'voucherList',
		components: {
			BackTo
		},
		data() {
			return {
				list: [],
				show: false,
				object: {}
			}
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		mounted() {
			this.getList()
		},
		methods: {
			getList() {
				this.$post(
					this.$activity + '/Coupon/GetExchangeList', {
						"pageIndex": 0,
						"pageSize": 0,
						"organizationId": this.$organizationId,
						"userId": this.userInfo.userId
					}
				).then(res => {
					this.list = res.items
				})
			},
			copy(exchangeInfo) {
				var input = document.createElement("input"); // 创建input对象
				input.value = exchangeInfo; // 设置复制内容
				document.body.appendChild(input); // 添加临时实例
				input.select(); // 选择实例内容
				document.execCommand("Copy"); // 执行复制
				document.body.removeChild(input); // 删除临时实例
				Toast.success('复制成功');
			}
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f5f5f5')
		}
	}
</script>

<style>
	.voucherList-con {
		width: 100%;
		padding: 20px;
		box-sizing: border-box;
	}

	.voucherList-con li {
		width: 100%;
		display: flex;
		height: 150px;
		background: #FFFFFF;
		border-radius: 20px;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 20px;
		padding: 0 30px;
		box-sizing: border-box;
	}

	.voucherList-left {
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
	}

	.voucherList-button {
		width: 128px;
		height: 50px;
		background: #FF7A09;
		border-radius: 25px;
		font-size: 22px;
		font-weight: 500;
		line-height: 50px;
		margin-left: auto;
		text-align: center;
		color: #FFFFFF;
	}

	.voucherList-title {
		font-size: 30px;
		font-weight: bold;
		color: #333333;
	}

	.voucherList-time {
		margin-top: 16px;
		font-size: 22px;
		font-weight: 400;
		color: #999999;
	}

	.voucherList-popup,
	.voucherList-pop,
	.voucherList-popup-img,
	.voucherList-popup-content {
		width: 600px;
		height: 673px;
		background-color: transparent;
	}

	.voucherList-pop {
		position: relative;
	}

	.voucherList-popup-content {
		position: absolute;
		top: 0;
		left: 0;
		padding: 30px;
		box-sizing: border-box;
	}

	.voucherList-popup-content h2 {
		font-size: 32px;
		font-weight: bold;
		color: #333333;
	}

	.voucherList-popup-contentc {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 32px;
		font-weight: 500;
		color: #FF7A09;
		margin-top: 102px;
		padding: 0 20px 0 40px;
		box-sizing: border-box;
	}

	.voucherList-popup-contentc p {
		width: 112px;
		height: 50px;
		background: #FFFFFF;
		border: 1px solid #E9E9E9;
		border-radius: 25px;
		font-size: 28px;
		font-weight: 500;
		line-height: 50px;
		color: #FF7A09;
		text-align: center;
	}

	.voucherList-popup-content_time {
		font-size: 26px;
		color: #999999;
		width: 100%;
		text-align: center;
		display: inline-block;
		padding-top: 19px;
	}

	.voucherList-popup-content_des {
		width: 100%;
		height: 261px;
		font-size: 28px;
		line-height: 42px;
		color: #666666;
		overflow: scroll;
		margin-top: 100px;
		display: inline-block;
	}
</style>
